import Vue from 'vue';
import hl from 'highlight.js';
import './highlight.css';
import '@coroot/coroot/src/plugins/highlight';

hl.configure({classPrefix: 'hl-'});

Vue.directive('hl', function (el, binding) {
    const lang = Object.keys(binding.modifiers)[0];
    const wrap = Object.keys(binding.modifiers)[1];
    let data = lang ? el.innerText : el.innerHTML;
    data = data.trim().replace('(((', '{{').replace(')))', '}}');
    if (lang) {
        data = hl.highlight(data, {language: lang}).value;
    }
    el.classList.add('hl');
    if (wrap) {
        el.classList.add('wrap');
    }
    el.innerHTML = data;
});
